var map = {
	"./en-US.js": [
		84270,
		1889
	],
	"./ja-JP.js": [
		64958,
		4958
	],
	"./ko-KR.js": [
		49704,
		9704
	],
	"./vi-VN.js": [
		78432,
		8432
	],
	"./zh-CN.js": [
		65348,
		5348
	],
	"./zh-TW.js": [
		52084,
		2084
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5871;
module.exports = webpackAsyncContext;